export default {
    list: {
        title: "公告中心",
        desc: "查看劍網3魔盒的最新動態、營運活動、功能更新與兌換通知。",
        searchPlaceholder: "請輸入關鍵字搜尋",
        sticky: "置頂",
        empty: "當前分類暫無公告內容",
        jump: "跳轉",
        authorDefault: "魔盒",
        tabs: {
            all: "全部",
            notice: "公告動態",
            information: "營運活動",
            feature: "功能更新",
            message: "兌換通知",
        },
    },
    single: {
        back: "返回列表",
        lastUpdated: "最後更新：{date}",
        views: "{count} 閱讀",
        edit: "編輯",
        manage: "管理",
        like: "讚 ({count})",
        star: "收藏",
        starred: "已收藏",
        comments: "評論",
        commentsClosed: "當前公告未開啟評論功能",
        visibilityTip: "作者設定了【{visibility}】",
        visibility: {
            public: "公開",
            self: "僅自己可見",
            friends: "僅親友可見",
            password: "密碼可見",
            paid: "付費可見",
            fans: "粉絲可見",
        },
    },
};
